import apiClient from '@/axios';
import { message } from 'ant-design-vue';
import router from '@/router';

const state = {
  authToken: localStorage.getItem('authToken') || '',
  user: JSON.parse(localStorage.getItem('user')) || {},
  company: {},
  leadsData: []
};
const mutations = {
  // setAuthToken(state, token) {
  //   state.authToken = token;
  // },
  SET_BEING_DATA(state, data) {
    state.leadsData = data;
  },
};
const getters = {
  user: state => state.user,
};

const actions = {
  async fetchLeads({ commit }, params) {
    try {
      const response = await apiClient.get('get-leads', {params});

      return response.data;
    } catch (error) {
      console.error('Error fetching leads data:', error);
    }
  },
  async fetchAssignedLeads({ commit }, params) {
    try {
      const response = await apiClient.get('get/assigned-leads', {params});

      return response.data;
    } catch (error) {
      console.error('Error fetching leads data:', error);
    }
  },
  async fetchClosedLeads({ commit }, params) {
    try {
      const response = await apiClient.get('get/close-leads', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching closed leads:', error);
      throw error;
    }
  },
  async assignLeads({ commit }, payload) {
    try {
      const { manual_leads: manualLeadsFlag, ...body } = payload;
      const config =
        manualLeadsFlag === 1 || manualLeadsFlag === true
          ? { params: { manual_leads: 1 } }
          : {};
      const response = await apiClient.post('/assign-leads', body, config);
      commit('SET_BEING_DATA', response);
      message.success(response.data.message);
      return response;
    } catch (error) {
      message.error(error.response.data.message);
      console.error('Error fetching contract data:', error);
    }
  },
  async closeLead({ commit }, payload) {
    try {
      const response = await apiClient.post('/close-leads', payload);
      message.success(response.data?.message || 'Lead closed successfully.');
      return response.data;
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to close lead.');
      throw error;
    }
  },
  async unassignClosedLead({ commit }, payload) {
    try {
      const response = await apiClient.post('/unassign-closed-leads', payload);
      message.success(response.data?.message || 'Lead unassigned successfully.');
      return response.data;
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to unassign lead.');
      throw error;
    }
  },
  async updateLead({ commit }, payload) {
    try {
      const response = await apiClient.post('/update-lead', payload);
      message.success(response.data?.message || 'Lead updated successfully.');
      return response.data;
    } catch (error) {
      // Let the form render field-level validation errors (422) under inputs.
      const hasFieldErrors = Boolean(error?.response?.data?.errors);
      if (!hasFieldErrors) {
        message.error(error.response?.data?.message || 'Failed to update lead.');
      }
      throw error;
    }
  },
  async createLead({ commit }, payload) {
    try {
      const response = await apiClient.post('/create-lead', payload);
      message.success(response.data?.message || 'Lead created successfully.');
      return response.data;
    } catch (error) {
      // Let the form render field-level validation errors (422) under inputs.
      const hasFieldErrors = Boolean(error?.response?.data?.errors);
      if (!hasFieldErrors) {
        message.error(error.response?.data?.message || 'Failed to create lead.');
      }
      throw error;
    }
  },
  async fetchLeadClosedReasons({ commit }) {
    try {
      const response = await apiClient.get('settings/get-dropdown-data', {
        params: { key: 'lead_closed_reason' },
      });
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching lead closed reasons:', error);
      return [];
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
